import { Typography } from "@mui/material";

const NewLabel = ({ style }) => {
  return (
    <div style={{height: 20, width: 50, backgroundColor: '#0758B7', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style}}>
      <Typography style={{fontSize: '12px', color: 'white', weight: 'bold'}}>NEW</Typography>
    </div>
  );
};

export default NewLabel;